import React from 'react';
import { ButtonProps } from './Button.types';
import './Button.styles.css';

export const Button: React.FC<ButtonProps> = ({
  children,
  variant = 'primary',
  size = 'medium',
  icon,
  iconPosition = 'left',
  fullWidth = false,
  disabled = false,
  loading = false,
  className = '',
  onClick,
  type = 'button',
  ...props
}) => {
  const buttonClasses = [
    'chatapp-button',
    `chatapp-button--${variant}`,
    `chatapp-button--${size}`,
    fullWidth && 'chatapp-button--full-width',
    disabled && 'chatapp-button--disabled',
    loading && 'chatapp-button--loading',
    className
  ].filter(Boolean).join(' ');

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (disabled || loading) {
      e.preventDefault();
      return;
    }
    onClick?.(e);
  };

  return (
    <button
      className={buttonClasses}
      onClick={handleClick}
      disabled={disabled || loading}
      type={type}
      {...props}
    >
      {loading ? (
        <span className="chatapp-button__loader">
          <svg className="chatapp-button__spinner" viewBox="0 0 24 24">
            <circle 
              cx="12" 
              cy="12" 
              r="10" 
              stroke="currentColor" 
              strokeWidth="3" 
              fill="none"
              strokeLinecap="round"
            />
          </svg>
        </span>
      ) : (
        <>
          {icon && iconPosition === 'left' && (
            <span className="chatapp-button__icon chatapp-button__icon--left">
              {icon}
            </span>
          )}
          <span className="chatapp-button__text">{children}</span>
          {icon && iconPosition === 'right' && (
            <span className="chatapp-button__icon chatapp-button__icon--right">
              {icon}
            </span>
          )}
        </>
      )}
    </button>
  );
};